import React from 'react';
import {AppHeader} from '@henrybuilt/react-lib';
import stLogo from '../assets/st-logo.png';
import hbLogo from '../assets/hb-logo-light.png';
import _ from 'lodash';
import {useParams} from 'react-router-dom';
import useDetectPrint from 'hooks/useDetectPrint';

const PageHeader = ({project, user, items, ...rest}) => {
  const params = useParams();
  const isPrinting = useDetectPrint();

  if (isPrinting) return null;

  const isDevelopment = process.env.NODE_ENV === 'development';
  const port = process.env.PORT || 3001;

  const companyKey = project?.companyKey || 'hb';
  const projectId = parseInt(params.projectId);

  const isEmployee = _.includes(['admin', 'employee'], user?.authGroup);
  const userId = user?.id;

  const baseUrl = isDevelopment ? `http://localhost:${process.env.HB_PORT || 3000}` : 'https://henrybuilt.com';
  const adminUrl = isDevelopment ? `http://localhost:${process.env.ADMIN_PORT || 3000}` : 'https://admin.henrybuilt.com';

  let links = _.filter([
    {key: 'henrybuilt', label: 'Henrybuilt.com', href: `${baseUrl}/`},
    {key: 'private-site', label: 'Private Site', href: `${baseUrl}/page/private-site`},
    {key: 'client', label: 'Client Site', href: `${baseUrl}/client`},
    {key: 'rorschach', label: 'Rorschach', href: `https://client.henrybuilt.com/projects/${projectId}/rorschach`},
    {key: 'design-engine', label: 'Design Engine', href: `${baseUrl}/design-engine`},
    {key: 'react-design-engine', label: 'DE React', href: `${isDevelopment ? `http://localhost:${port}/` : 'https://design-engine.henrybuilt.com'}`},
    {key: 'weflow', label: 'Weflow', href: 'https://www.weflowapp.com'},
    {key: 'pricing-tool', label: 'Pricing Tool', href: `${baseUrl}/pricing_tool`},
    {key: 'project-manager', label: 'Project Manager', href: `${baseUrl}/project-manager`},
    {key: 'modeler', label: 'Modeler', href: `${baseUrl}/modeler`},
    {key: 'documentation', label: 'Documentation', href: `${baseUrl}/documentation`},
    {key: 'admin-media-library', label: 'Media Library', href: `${adminUrl}/media`},
    {key: 'admin', label: 'Admin', href: `${baseUrl}/admin`},
    {key: 'my-account', label: 'My Account', href: `${baseUrl}/users/${userId}`}
  ], link => {
    var include = false;

    if (link.key === 'react-design-engine' && isEmployee) {
      include = true;
    }

    if (_.includes(['henrybuilt', 'design-engine', 'react-design-engine', 'my-account'], link.key)) {
      include = true;
    }

    if (_.includes(['client', 'private-site'], link.key) && isEmployee) {
      include = true;
    }

    if (_.includes(['weflow', 'pricing-tool', 'modeler', 'documentation', 'admin', 'admin-media-library', 'project-manager'], link.key) && isEmployee) {
      include = true;
    }

    if (_.includes(['rorschach'], link.key) && projectId && isEmployee) {
      include = true;
    }

    return include;
  });

  links = _.map(links, ({key, label, href}) => {
    const hasProject = _.includes(_.split(window.location.pathname, '/'), 'projects') && project;

    if (hasProject && _.includes(['project-manager', 'design-engine', 'pricing-tool'], key)) {
      label += ` - #${projectId}`;

      if (key === 'pricing-tool') href += `/projects/${projectId}`;
      if (key === 'design-engine') href += `/projects/${projectId}/drafts/${project.lastVersionId}/layout`;
      if (key === 'project-manager') href += `/projects/${projectId}/drafts/${project.lastVersionId}/lists/products-list-form`;
    }

    if (hasProject && _.includes(['react-design-engine', 'rorschach'], key)) {
      if (isDevelopment) {
        href = `http://localhost:${port}`;
      }

      label += ` - #${projectId}`;

      if (key === 'react-design-engine') {
        href += `/projects/${projectId}/drafts/${project.lastVersionId}/layout`;
      }
      else if (key === 'rorschach') {
        if (!isDevelopment) {
          href = 'https://client.henrybuilt.com';
        }
        href += `/projects/${projectId}/rorschach`;
      }
    }

    return {key, label, href};
  });

  return (
    <AppHeader {...{items, links, ...rest}} logo={companyKey === 'hb' ? hbLogo : stLogo} />
  );
};

export default PageHeader;
